<div *ngIf="attributions && attributions.length > 0" class="wrapper">
    <div class="container">
        <div class="row">
            <h4 class="selenium-attributions-header" style="margin: 20px 0">
                Made Possible Through
            </h4>
        </div>
        <div class="row">
            <app-attributes [attributions]="attributions"></app-attributes>
        </div>
    </div>
</div>
